<template>
  <div class="search-box">
    <el-input
      :placeholder="placeholderName"
      v-model.trim="searchKey"
      @keyup.enter.native="onSearchKey"
      :size="size"
    >
      <i slot="suffix" class="icon-search-box" @click="onSearchKey">
        <span class="el-icon-search"></span>
      </i>
    </el-input>
    <el-button
      v-if="buttonShow"
      class="search-button"
      type="primary"
      @click="onSearchKey"
      >搜索</el-button
    >
  </div>
</template>

<script>
export default {
  name: 'search-box',
  props: {
    size: {
      type: String,
      default: ''
    },
    placeholderName: {
      type: String,
      default: '请输入名称'
    },
    buttonShow: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      searchKey: ''
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  methods: {
    onSearchKey() {
      this.$emit('onSearchKey', this.searchKey)
    },
    onSearchKeyText(val) {
      this.searchKey = val || ''
    }
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="scss" scoped>
.search-box {
  width: 420px;
  border-radius: 4px;
  font-size: 16px;
  color: #7a7c84;
  box-sizing: border-box;
  display: flex;
  &::-ms-clear {
      display: none;
  }
  .icon-search-box {
    height: 100%;
    font-size: 20px;
    display: flex;
    align-items: center;
    margin-right: 3px;
    cursor: pointer;
  }
  .search-button {
    background: #4c88ff;
    margin-left: 10px;
  }
  .el-button {
    padding: 0 20px;
  }
}
</style>